// Fill in these values after deploying the AICG2-Auth and AICG2-AnnotationApi stacks.
// Run: cdk deploy --all --profile aicgapp
// Then check the CloudFormation Outputs tab for each stack.

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID ?? '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID ?? '',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN ?? 'aicg2-annotators.auth.us-west-2.amazoncognito.com',
          scopes: ['email', 'profile', 'openid'] as ('email' | 'profile' | 'openid')[],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: 'code' as const,
        },
      },
    },
  },
};

export const API_URL = (process.env.REACT_APP_API_URL ?? '').replace(/\/$/, '');

export default awsConfig;
